import styled from "styled-components";

export const ChatCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const ChatHeader = styled.div`
  padding: 18px 22px;
  border-bottom: 1px solid #eef3f7;
  color: #1b2b3a;
  font-size: 1rem;
  font-weight: 700;
  flex-shrink: 0;
`;

export const MessageList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  justify-content: ${({ $own }) => ($own ? "flex-end" : "flex-start")};
`;

export const Avatar = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const Bubble = styled.div`
  max-width: 72%;
  padding: 10px 14px 6px;
  border-radius: 8px;
  background: ${({ $own }) => ($own ? "#f1f2f4" : "#d6e8f5")};
  color: #1b2b3a;
  font-size: 0.85rem;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const BubbleTime = styled.div`
  margin-top: 4px;
  font-size: 0.68rem;
  color: #7a8794;
  text-align: right;
`;

/* ---- Mensaje del sistema (aceptado / rechazado / cancelado) ---- */
export const SystemRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const SystemBubble = styled.div`
  background: #f1f2f4;
  border-radius: 8px;
  padding: 10px 16px 6px;
  color: #55606b;
  font-size: 0.78rem;
  text-align: center;
`;

/* ---- Tarjeta de propuesta de videoconsulta ---- */
export const ProposalCard = styled.div`
  background: #f1f2f4;
  border-radius: 8px;
  padding: 14px 18px 8px;
  max-width: 420px;
  margin-left: ${({ $own }) => ($own ? "auto" : "0")};
`;

export const ProposalOutcome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ $outcome }) => ($outcome === "accepted" ? "#27803f" : "#a33")};
  padding: 6px 0 2px;
  border-top: 1px solid #e2e5e9;
`;

export const ProposalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #1b2b3a;
  font-size: 0.85rem;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const ProposalText = styled.p`
  margin: 0 0 12px;
  font-size: 0.82rem;
  color: #333;
  text-align: center;

  strong { font-weight: 700; }
`;

export const ProposalActions = styled.div`
  display: flex;
  gap: 10px;
`;

export const AcceptButton = styled.button`
  flex: 1;
  padding: 9px 12px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const DeclineButton = styled.button`
  flex: 1;
  padding: 9px 12px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const EmptyMsg = styled.p`
  margin: auto;
  color: #9aa7b2;
  font-size: 0.85rem;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  border-top: 1px solid #eef3f7;
  flex-shrink: 0;
`;

export const ChatInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e6ecf1;
  background: #f7f9fb;
  font-size: 0.85rem;
  color: #333;
  outline: none;

  &:focus { border-color: #26A9B6; background: #fff; }
  &::placeholder { color: #9aa7b2; }
`;

export const SendButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  border-radius: 8px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;

  &:hover { background: #175a65; }
  &:disabled { opacity: 0.45; cursor: not-allowed; }
`;
